import { mapActions } from "vuex";
import { getUserInfo } from "@saas/server-api/src";
export default {
  methods: {
    ...mapActions("user", ["getInfo"]),
    loginSuccess() {
      if (!window.isElectron) {
        if (this.$currentLoginDialog) {
          setTimeout(() => {
            this.$currentLoginDialog.loginSuccess(); // 关闭对话框
          }, 500);
          // // 获取用户信息
          // this.getInfo();
          // // 刷新当前页面
          // this.$router.go(0);
        }
      } else {
        const { return_url = "" } = this.$route.query;
        if (return_url) {
          this.$router.replace({ path: return_url });
        } else {
          this.$router.replace({ path: "/" });
        }

        // 获取用户信息
        this.getInfo("login");
      }
    },
    async checkIdentity() {
      try {
        const res = await getUserInfo();
        if (res.code === 1) {
          if (!res.data?.user_identity || res.data?.user_identity < 1) {
            // 么有身份
            return false;
          } else {
            // 有身份
            return true;
          }
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    },
  },
};
